import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67e4e013"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer-copyright" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "logo-part" }
const _hoisted_4 = { class: "logo" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "agreement" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "part part-icbc" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
}

import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

let store = useStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: require('@/assets/img/index/logo.png'),
            alt: "logo"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", {
            target: "_blank",
            href: _unref(store).state.prosperityObj?.usertcp
          }, "用户协议", 8, _hoisted_7),
          _createElementVNode("a", {
            target: "_blank",
            href: _unref(store).state.prosperityObj?.privacypolicy
          }, "隐私政策", 8, _hoisted_8)
        ])
      ]),
      _createElementVNode("div", {
        class: "txt",
        innerHTML: _unref(store).state.prosperityObj?.footer
      }, null, 8, _hoisted_9),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("img", {
          class: "icbc",
          src: require('@/assets/img/index/icbc.png'),
          alt: "icbc"
        }, null, 8, _hoisted_11),
        _createTextVNode("工商网监电子标识 | "),
        _createElementVNode("a", _hoisted_12, _toDisplayString(_unref(store).state.prosperityObj?.icp), 1)
      ])
    ])
  ]))
}
}

})